import fb from '../firebase'
import FirebaseHelpers from '../helpers/FirebaseHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ListHelpers from '../helpers/ListHelpers'

var db = fb.database()

const state = {
    groups: []
}

// getters
const getters = {

    groups: state => {
        return state.groups
    },

}

// actions
const actions = {

    fetchAllGroups(context) {
        return new Promise(function(resolve, reject) {
            if(context.getters.groups.length) {
                resolve(context.getters.groups)
                return
            }

            let ref = db.ref(`tenants/${context.getters.tenantKey}/groups`)
            ref.on('value', function(snap) {
                console.log('store > fetchAllgroups (first load)')
                let groups = []
                snap.forEach(function(item){
                    let group = {
                        key: item.key,
                        name: item.val().name,
                        role: item.val().role,
                        stamp: item.val().stamp,
                    }
                    groups.push(group)
                })
                groups = groups.sort((a,b) => a.name > b.name)
                context.commit('groups', groups)
                resolve(groups)
            })  
        })
    },
}

// mutations
const mutations = {

    groups (state, groups) {
        state.groups = groups           
    }, 
    deleteGroup (state, group) {
        ListHelpers.delete(group, state.groups)          
    },                  
}

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/GroupsStore.js